import styled from 'styled-components';
import { breakpoint } from 'styled-components-breakpoint';

import TableTheme from '../Themes/SaberLight/Table';

export const StyledTable = styled.table`
  border-collapse: collapse;

  font-family: 'Lato';

  text-align: left;

  width: 100%;

  thead {
    background-color: ${({ theme }) => theme.tableHeaderBg};
    color: ${({ theme }) => theme.tableHeaderText};
  }

  tbody {
    background-color: ${({ theme }) => theme.tableBodyBg};
  }

  tbody tr:not(:first-child) {
    border-top: 2px solid grey;
  }

  td,
  th {
    white-space: nowrap;
    padding: 0.75em 1em;
  }
`;

export const Wrapper = styled.div`
  box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.1);

  overflow-x: scroll;

  ${breakpoint('tablet')`
    overflow-x: auto;
  `}
`;

export const Chevron = styled.div`
  cursor: pointer;
  display: flex;

  margin-right: 0.5rem;

  &.selected-up {
    transform: rotate(-90deg);
  }

  &.selected-down {
    transform: rotate(90deg);
  }
`;

export const THContent = styled.div`
  display: flex;
  align-items: center;
`;

StyledTable.defaultProps = {
  theme: {
    tableBodyBg: TableTheme.tableBodyBg,
    tableHeaderBg: TableTheme.tableHeaderBg,
    tableHeaderText: TableTheme.tableHeaderText,
  },
};
